import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(2, 4, 1),
  },
  button: {
    '&.MuiButton-root': {
      textTransform: 'none',
    },
  },
  attentionNote: {
    color: theme.palette.text.disabled,
    marginTop: `${theme.spacing(0.5)} !important`,
  },
  infoIcon: {
    fontSize: theme.spacing(2),
    marginTop: theme.spacing(1.75),
  },
}));
